export default {
	multiTask: {
		app: "Приложение",
		upgrade: "Обновление",
		processPid: "pid процесса",
		working: "Работающие",
		completed: "Завершенные",
		completedWithError: "Завершенные с ошибкой",
		infoAboutThisTaskYouCanSeeInStatus: "Информацию по этим задачам можно посмотреть в статусе задач, отфильтровав по комментарию",
		currentPackageComment: "Комментарий текущей пачки",
		task: "Задача",
		fileSelect: "Выбор файла",
		youRun: "Вы запустили",
		tasks: "задач",
		successfully: "Успешно",
		moreDetails: "Подробнее",
		clearResults: "Очистить результаты",
		clear: "Очистить",
		start: "Запуск",
		noAppsSelectedError: "Не выбрано ни одно приложение",
		enterStartMessage: "Введите сообщение для запуска",
		noSuchTasks: "Не найдены запущенные задачи",
		tooLongOperation: "Долгое время выполнения задач, прекращается выполнение запросов",
		presetElementNotFound: "Один из элементов пресета не найден в дереве",
		enter: "Ввести",
		cancellation: "Отмена",
		busyTasks: "Занятые задания"
	},
	runTask: {
		fileSelect: "Выбор файла",
		result: "Результат",
		forMoreDetailsAboutValueLookConsole: "Для дополнительной информации о возвращенном значении посмотрите консоль",
		cancel: "Отменить",
		exit: "Выход",
		server: "Сервер",
		app: "Приложение",
		autoLoading: "Авто-загрузка",
		administration: "Администрирование",
		appliedTasks: "Прикладные задачи",
		itsMistake: "Это ошибка",
		shortMessage: "короткое сообщение",
		plsRefreshPage: "Обновите, пожалуйста, страницу"
	}
}